export default __webpack_public_path__ + "static/media/logo_bap.d122eb66.png";